import { useParams } from "react-router";
import { useSqids } from "../../hooks/useSqids";
import SandpackProjectMain from "./sandpackProject/SandpackProjectMain";
import { useQuery } from "@tanstack/react-query";
import { qoGetProjectWithUserData } from "../../utils/queryOptions";
import { useAuth } from "../../hooks/useAuth";

export default function ProjectLoader() {
  const { user } = useAuth();
  const { projectSlugWithId } = useParams();
  const sqids = useSqids();
  const encodedId = projectSlugWithId!.split("-").pop(); // "UkLWZg"
  const projectId = sqids.decode(encodedId!);

  /*
    TODO 
    - project_details -> project_type -> github, sandpack, stackblitz, vs
    - project_type'a göre ilgili modül yüklenecek
   */

  const { data: project, isSuccess } = useQuery(
    qoGetProjectWithUserData({
      project_id: Number(projectId),
      user_id: user!.id
    })
  );

  if (!isSuccess) {
    return "Yükleniyor";
  }

  if (!project?.project) {
    return (
      <div className="w-full h-screen flex items-center justify-center text-white/50">
        Proje bulunamadı (ID: {String(projectId)})
      </div>
    );
  }

  return <SandpackProjectMain projectData={project} user={user!} />;
}
